import { ReactElement } from "react";
import CorporateList from "../../components/Corporate";
import Layout from "../../components/layout";

const CorporatePage = (): ReactElement => {
  return (
    <Layout>
      <CorporateList />
    </Layout>
  );
};

export default CorporatePage;
